import axios from 'axios';

import {
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    USER_LOADED_SUCCESS,
    AUTHENTICATED_SUCCESS,
    AUTHENTICATED_FAIL,
    PASSWORD_RESET_SUCCESS,
    PASSWORD_RESET_FAIL,
    PASSWORD_RESET_CONFIRM_SUCCESS,
    PASSWORD_RESET_CONFIRM_FAIL,
    SIGNUP_SUCCESS,
    SIGNUP_FAIL,
    ACTIVATION_SUCCESS,
    ACTIVATION_FAIL,
    GOOGLE_AUTH_SUCCESS,
    GOOGLE_AUTH_FAIL,
    FACEBOOK_AUTH_SUCCESS,
    FACEBOOK_AUTH_FAIL,
    LOGOUT,
    USER_LOADED_ADMIN
} from './types';
import { api_address } from '../../utils/api_address';
import {store} from '../store';
import { request_refreshed , request_noauth} from '../../utils/axios-utils';

export const getCsrfToken = () => {
    let csrf;
    try{csrf = document.cookie.match('(^|;)\\s*csrftoken\\s*=\\s*([^;]+)')
        return csrf ? csrf.pop() : ''}
    catch{ 
        return ''; 
        }    
 }
  ;

  export const getCsrfToken1 = async () => {
    const response = await axios.get('/api/auth/csrf/',{
         headers: {
             Accept: 'application/json',
             'Content-Type': 'application/json'
         }
     });
     const data = response.data.CSRFToken;

     return data
 } 

export function ValidateEmail(email) 
{
 if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email))
  {
    return (true)
  }
    // alert("You have entered an invalid email address!")
    return (false)
}




export const load_user = (setSuccess, setisAdmin,setloading) => async dispatch  =>{
    if (store.getState().auth?.access) {

    const res =  await request_refreshed('/auth/users/me/','get',{})
    
    dispatch({
        type: USER_LOADED_SUCCESS,
        payload: res.data
    });

    var today = new Date();
    let hr = today.getHours() ;
    let day = today.toLocaleString('en-us', {  weekday: 'long' });
    let minutes  = today.getMinutes();

    const res2 = await request_refreshed('/api/auth/login/','post',
    {"email":res.data.email,
    "platform":"web",
    "isTablet":false,
    "model":"na",
    "brand":"na",
    "device_id":"",
    "hour": hr,
    "day": day,
    "minutes": minutes,
    "datetime": today
})

    let isAdmin = res2.data.isAdmin==1 ? true : false

    setisAdmin(isAdmin)

    setTimeout(() => { 
        setSuccess(true)
    }, 500)
    dispatch({
        type: USER_LOADED_ADMIN,
        payload: isAdmin
    })

}
setloading(false)
}

export const googleAuthenticate = (state, code) => async dispatch => {
    if (state && code && !store.getState().auth.access) {

        if(getCsrfToken()!=''){
            var config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    "X-CSRFToken" : getCsrfToken()
                }}
          
        }else{
    
        var config= {
            headers: {
             'Content-Type': 'application/x-www-form-urlencoded',
              'Accept': 'application/json'}
            };
        }

        const details = {
            'state': state,
            'code': code
        };

        const formBody = Object.keys(details).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(details[key])).join('&');

        try {
            const res = await axios.post(`${api_address}//auth/o/google-oauth2/?${formBody}`, config);

            dispatch({
                type: GOOGLE_AUTH_SUCCESS,
                payload: res.data
            });

            dispatch(load_user());
        } catch (err) {
            dispatch({
                type: GOOGLE_AUTH_FAIL
            });
        }
    }
};

export const facebookAuthenticate = (state, code) => async dispatch => {
    if (state && code && !store.getState().auth.access) {
        if(getCsrfToken()!=''){
            var config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    "X-CSRFToken" : getCsrfToken()
                }}
          
        }else{
    
        var config= {
            headers: {
             'Content-Type': 'application/x-www-form-urlencoded',
              'Accept': 'application/json'}
            };
        }

        const details = {
            'state': state,
            'code': code
        };

        const formBody = Object.keys(details).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(details[key])).join('&');

        try {
            const res = await axios.post(`${api_address}/auth/o/facebook/?${formBody}`, config);

            dispatch({
                type: FACEBOOK_AUTH_SUCCESS,
                payload: res.data
            });

            dispatch(load_user());
        } catch (err) {
            dispatch({
                type: FACEBOOK_AUTH_FAIL
            });
        }
    }
};

export const checkAuthenticated = () => async dispatch => {
    if (store.getState().auth.access) {
        if(getCsrfToken()!=''){
            var config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    "X-CSRFToken" : getCsrfToken()
                }}
          
        }else{
    
        var config= {
            headers: {
             'Content-Type': 'application/json',
              'Accept': 'application/json'}
            };
        }

        const body = JSON.stringify({ token: store.getState().auth.access });

        try {
            const res = await axios.post('/auth/jwt/verify/', body, config)

            if (res?.data?.code !== 'token_not_valid') {
                dispatch({
                    type: AUTHENTICATED_SUCCESS
                });
            } else {
                dispatch({
                    type: AUTHENTICATED_FAIL
                });
            }
        } catch (err) {
            dispatch({
                type: AUTHENTICATED_FAIL
            });
        }

    } else {
        dispatch({
            type: AUTHENTICATED_FAIL
        });
    }
};


export const signup = (first_name, email, password, re_password) => async dispatch => {
    if(getCsrfToken()!=''){
        var config = {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "X-CSRFToken" : getCsrfToken()
            }}
      
    }else{

    var config= {
        headers: {
         'Content-Type': 'application/json',
          'Accept': 'application/json'}
        };
    }


    const body = JSON.stringify({ first_name, email, password, re_password });

    try {
        const res = await axios.post('/auth/users/', body, config)
        // .catch(err => {console.log(err.response.data)})
        
        dispatch({
            type: SIGNUP_SUCCESS,
            payload: res.data
        });
    } catch (err) {
        dispatch({
            type: SIGNUP_FAIL
        })
    }
};

export const verify = (uid, token) => async dispatch => {
    if(getCsrfToken()!=''){
        var config = {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "X-CSRFToken" : getCsrfToken()
            }}
      
    }else{

    var config= {
        headers: {
         'Content-Type': 'application/json',
          'Accept': 'application/json'}
        };
    }


    const body = JSON.stringify({ uid, token });

    try {
        await axios.post('/auth/users/activation/', body, config);

        dispatch({
            type: ACTIVATION_SUCCESS,
        });
    } catch (err) {
        dispatch({
            type: ACTIVATION_FAIL
        })
    }
};

export const resend_activation = (email) => async dispatch => {
    if(getCsrfToken()!=''){
        var config = {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "X-CSRFToken" : getCsrfToken()
            }}
      
    }else{

    var config= {
        headers: {
         'Content-Type': 'application/json',
          'Accept': 'application/json'}
        };
    }


    const body ={"email": email};

    axios.post('/api/resend-activation/', body, config).then(function (response) {
        response.data;
      })
      .catch(function (error) {
      });}


export const login = (email, password, setSuccess,setisAdmin,setloading,setloginerror) => async dispatch => {
    const body = JSON.stringify({ email, password });
    setloading(true)
    try{
    let res
    try{ res = await request_noauth(
        '/auth/jwt/create/','post',
      {'email':email,'password':password})
      }catch(error) {
           if(error.response.status=='403'){
              try{ setloginerror(error.response.data['error'])}catch{}
           }else{
           try{setloginerror()}catch{}
           }
           setSuccess(false)
         }

        //  console.log('res.status',res.data)
if(res?.status==200){
    dispatch({ type: LOGIN_SUCCESS,
        payload: res.data
    });
    dispatch(load_user(setSuccess,setisAdmin,setloading));
}
} catch (err) {
    console.log('err',err)
        dispatch({
            type: LOGIN_FAIL
        })
        setSuccess(false);
    }
    setloading(false)
};




export const reset_password = (email) => async dispatch => {
    if(getCsrfToken()!=''){
        var config = {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "X-CSRFToken" : getCsrfToken()
            }}
      
    }else{

    var config= {
        headers: {
         'Content-Type': 'application/json',
          'Accept': 'application/json'}
        };
    }


    const body = JSON.stringify({ email });

    try {
        await axios.post('/auth/users/reset_password/', body, config);

        dispatch({
            type: PASSWORD_RESET_SUCCESS
        });
    } catch (err) {
        dispatch({
            type: PASSWORD_RESET_FAIL
        });
    }
};

export const reset_password_confirm = (uid, token, new_password, re_new_password,setsuccess) => async dispatch => {
    if(getCsrfToken()!=''){
        var config = {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "X-CSRFToken" : getCsrfToken()
            }}
      
    }else{

    var config= {
        headers: {
         'Content-Type': 'application/json',
          'Accept': 'application/json'}
        };
    }


    const body = JSON.stringify({ uid, token, new_password, re_new_password });

    try {
        const res = await axios.post('/auth/users/reset_password_confirm/', body, config);
        setsuccess(true)
        dispatch({
            type: PASSWORD_RESET_CONFIRM_SUCCESS
        });


        if(res.status==200){
            let res2 = await request_noauth(navigate,'/api/reset/confirm/','post',{})
        }
        
    } catch (err) {
        dispatch({
            type: PASSWORD_RESET_CONFIRM_FAIL
        });
        setsuccess(false)
    }
};

export const logout = () => dispatch => {
    // localStorage.clear();
    dispatch({
        type: LOGOUT
    });
    dispatch({
        type: USER_LOADED_ADMIN,
        payload: false
    })
};


export const continueWithGoogle = (setgoogle_url) => async dispatch => {

        if(getCsrfToken()!=''){
            var config = {
                headers: {
                    'Content-Type': 'application/json',
                    "X-CSRFToken" : getCsrfToken()
                }}
          
        }else{
    
        var config= {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'}
            };
        }

    // try {
        const res = await axios.get('/auth/o/google-oauth2/?redirect_uri='+api_address+'/google',
        config)
        // .catch(err => {console.log(err.response.data)})

        setgoogle_url(res?.data?.authorization_url);
  
    // } catch (err) {
  
    // }
  };